<div class="payment-list">
    <div class="payment-card" *ngIf="currentMethodPayment?.hasPaymentMethod">
        <div>
            <img src="assets/credit-cards/{{getCardBrand(currentMethodPayment?.cardInfo?.brand)}}-curved-128px.png"
                alt="{{getCardBrand(currentMethodPayment?.cardInfo?.brand)}}" class="card-logo" />
        </div>
        <div class="card-details">
            <span class="card-type">
                {{ getCardTypeLabel(currentMethodPayment?.cardInfo?.brand) }}
            </span>
            <span class="card-number">{{ formatCardNumber(currentMethodPayment?.cardInfo?.last4) }}</span>
        </div>
        <div class="default-label none">
            <p-message severity="secondary">{{ 'payment.default' | transloco }}</p-message>
        </div>
        <button pButton [icon]="cardActions.EDIT_ACTION_CIRCLE.icon ?? ''" [class]="cardActions.EDIT_ACTION_CIRCLE.styleClass" (click)="openDirect ? openPaymentMethodDialog() : menu.toggle($event)">
        </button>
    </div>


    <div class="payment-card" *ngIf="false">
        <div>
            <img src="assets/credit-cards/visa-curved-128px.png" alt="Visa" class="card-logo" />
        </div>
        <div class="card-details">
            <span class="card-type">Visa Debit Card</span>
            <span class="card-number">•••• •••• •••• 1234</span>
        </div>
        <div class="default-label none">
            <p-message severity="secondary">Predeterminada</p-message>
        </div>
        <button pButton [icon]="cardActions.EDIT_ACTION_CIRCLE.icon ?? ''" [class]="cardActions.EDIT_ACTION_CIRCLE.styleClass"
            (click)="menu.toggle($event)">
        </button>
    </div>

    <p-menu #menu [model]="items" [popup]="true" />
    <button *ngIf="!currentMethodPayment?.hasPaymentMethod" pButton [icon]="cardActions.ADD_METHOD_PAYMENT_BUTTON.icon ?? ''"
        [class]="cardActions.ADD_METHOD_PAYMENT_BUTTON.styleClass"
        [label]="(cardActions.ADD_METHOD_PAYMENT_BUTTON.labelKey | transloco) ?? ''" class="fit-content-button" (click)="openPaymentMethodDialog()">
    </button>
</div>
<app-stripe-payment #stripePayment (paymentCompleted)="completeAddMethodPayment($event)"></app-stripe-payment>